export default __webpack_public_path__ + "static/cercle_vicieux_en-6e8882a450897444d93147ca6bd9ad18.mp4";